import React, { useEffect, useState } from "react";
import { transformResultsToTableData } from "../../../../services/commonService";
import InsightTable from "../InsightTable";

function WorkforceAndHiringTrends({ workforceAndHiringTrends }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     global_workforce: "b",
  //     expansion_focus: "c",
  //     hiring_trends: "d",
  //     global_workforce_positive_insight: "b",
  //     global_workforce_negative_insight: "b",
  //     global_workforce_recent_development: "b",
  //     expansion_focus_positive_insight: "c",
  //     expansion_focus_negative_insight: "c",
  //     expansion_focus_recent_development: "c",
  //     hiring_trends_positive_insight: "d",
  //     hiring_trends_negative_insight: "d",
  //     hiring_trends_recent_development: "d",
  //   },
  //   {
  //     competitor: "e",
  //     global_workforce: "f",
  //     expansion_focus: "g",
  //     hiring_trends: "h",
  //     global_workforce_positive_insight: "b",
  //     global_workforce_negative_insight: "b",
  //     global_workforce_recent_development: "b",
  //     expansion_focus_positive_insight: "c",
  //     expansion_focus_negative_insight: "c",
  //     expansion_focus_recent_development: "c",
  //     hiring_trends_positive_insight: "d",
  //     hiring_trends_negative_insight: "d",
  //     hiring_trends_recent_development: "d",
  //   },
  // ];
  useEffect(() => {
    const tableData = transformResultsToTableData(workforceAndHiringTrends);
    setTabData(tableData);
  }, [workforceAndHiringTrends]);

  const tableColumns = [
    { key: "global_workforce", label: "Global Workforce", width: "120px" },
    { key: "expansion_focus", label: "Expansion Focus" },
    { key: "hiring_trends", label: "Hiring Trends" },
  ];

  return (
    <InsightTable
      title="Workforce & Hiring Trends"
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default WorkforceAndHiringTrends;
